// src/header/Menu.jsx
import React from 'react';
import MenuOff from '../content/Menuoff';
import { useAuth } from '../AuthContext';

import './menu.css';

export const Menu = () => {
  const { user, loading } = useAuth();

  // Nu afișa nimic până când verificarea utilizatorului se termină
  if (loading) {
    return <div className="menu-items"><div className="align-header-elements-logged"></div></div>;
  }

  return (
    <div className="menu-items">
      <div className="align-header-elements-logged">
        {!user && <MenuOff />}
      </div>
    </div>
  );
};
